import { ProviderNames } from 'hooks/dispatch/utils'
import { useServiceProxy } from 'hooks/kong'
import { StandardServiceCall } from 'types/aaa'

export function useDispatchRefetch(callKey: string, provider: string) {
  const serviceProxy = useServiceProxy()
  return async () => {
    try {
      if (provider === ProviderNames.AAA) {
        await serviceProxy<StandardServiceCall>('get', `/serviceproxy/aaa/dispatch/${callKey}`)
      }
    } catch (e) {
      console.error(e)
    }
  }
}

export default useDispatchRefetch
